import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

// Connects to data-controller="range-flatpickr"
export default class extends Controller {
  static targets = ["date"];
  static values = {
    minDate: String,
    maxDate: String,
  };

  connect() {
    this.datepicker();
  }

  datepicker() {
    if (this.hasDateTarget) {
      flatpickr(this.dateTarget, {
        locale: "ja",
        static: true,
        dateFormat: "Y/m/d",
        allowInput: true,
        minDate: this.minDateValue,
        maxDate: this.maxDateValue,
      });
    }
  }
}
